// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"630":"05674014","694":"a4ce42b5"}[chunkId] + ".js";
};